<template>
  <!-- <transition name="modal" > -->
  <div id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close-button" @click="$emit('close')">X</button>
          <div class="modal-body-body">
            <slot name="body">
              <div class="img-top-container">
                <img :src="logo" alt="Logo Strongbow" />
              </div>
              <div class="text-top-container">
                <h2>Información de Productos</h2>
              </div>
              <div class="info-container">
                <div class="card-container">
                    <div class="box" :class="{onlySafari: isSafari}">
                        <img :src="botella_gold" alt="Botella Gold Apple" />
                        <h3 class="gold">Gold Apple</h3>
                        <p><strong>INGREDIENTES:</strong><br>Sidra natural, agua, sacarosa, jugo de manzana, saborizantes naturales, caramelo puro, ácido cítrico, <b>metabisulfito de potasio</b>.</p>
                        <p><strong>DECLARACIÓN NUTRIMENTAL POR 100 ML:</strong><br>Contenido energético 57 kcal (240 kJ), grasas totales 0 g, de las cuales: Grasas saturadas 0 g, hidratos de carbono disponibles 8.2 g, de los cuales: Azúcares 7.5 g, proteínas {{'<'}} 0.3 g, sodio {{'<'}} 0.01 g</p>
                    </div>
                    <div class="box" :class="{onlySafari: isSafari}">
                        <img :src="botella_honey" alt="Botella Honey" />
                        <h3 class="honey">Honey</h3>
                        <p><strong>INGREDIENTES:</strong><br>Sidra natural, agua, sacarosa, jugo de manzana, saborizantes naturales, caramelo puro, ácido cítrico, <b>metabisulfito de potasio</b>.</p>
                        <p><strong>DECLARACIÓN NUTRIMENTAL POR 100 ML:</strong><br>Contenido energético 62 kcal (260 kJ), grasas totales 0 g, de las cuales: Grasas saturadas 0 g, hidratos de carbono disponibles 9.5 g, de los cuales: Azúcares 8.7 g, proteínas {{'<'}} 0.3 g, sodio {{'<'}} 0.01 g  </p>
                    </div>
                    <div class="box" :class="{onlySafari: isSafari}">
                        <img :src="botella_berries" alt="Botella Red Berries" />
                        <h3 class="berries">Red Berries</h3>
                        <p><strong>INGREDIENTES:</strong><br>Sidra natural, agua, sacarosa, jugo de manzana, jugo de sauco, saborizantes naturales, ácido cítrico, <b>metabisulfito de potasio</b>.</p>
                        <p><strong>DECLARACIÓN NUTRIMENTAL POR 100 ML:</strong><br>Contenido energético 59 kcal (247 kJ), grasas totales 0 g, de las cuales: Grasas saturadas 0 g, hidratos de carbono disponibles 8.7 g, de los cuales: Azúcares 7.7 g, proteínas {{'<'}} 0.3 g, sodio {{'<'}} 0.01 g  </p>
                    </div>
                    <div class="box" :class="{onlySafari: isSafari}">
                        <img :src="botella_rose" alt="Botella Rosé Apple" />
                        <h3 class="rose">Rosé Apple</h3>
                        <p><strong>INGREDIENTES:</strong><br>Sidra natural, agua, sacarosa, jugo de manzana, jugo de frutas, saborizantes naturales, ácido málico, <b>metabisulfito de potasio</b>.</p>
                        <p><strong>DECLARACIÓN NUTRIMENTAL POR 100 ML:</strong><br>Contenido energético 43 kcal (180 kJ), grasas totales 0 g, de las cuales: Grasas saturadas 0 g, hidratos de carbono disponibles 4.6 g, de los cuales: Azúcares 3.8 g, proteínas {{'<'}} 0.3 g, sodio {{'<'}} 0.01 g  </p>
                    </div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import logo from '@/assets/Logo_Strongbow.png'
import botella_gold from '@/assets/BOTELLAGOLDAPPLE.png';
import botella_honey from '@/assets/BOTELLAHONEY.png';
import botella_berries from '@/assets/BOTELLAREDBERRIES.png';
import botella_rose from '@/assets/BOTELLAROSEAPPLE.png';
import Bowser from "bowser";
export default {
  name: "ModalInfoProduct",
  data() {
    return {
      logo,
      botella_gold,
      botella_honey,
      botella_berries,
      botella_rose,
      isSafari: false
    };
  },
  components: {},
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  },
  methods: {
    closeGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
  },
  async mounted(){
    tagFunctions.user_interactionPush('view', 'popup informacion del producto', 'footer');
  },
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/modalInfoProduct.scss";
</style>

